<template>
  <gg-card>
    <gg-card-header>
      Media Files
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <v-form>
            <v-file-input v-model="files.logoFile"
                          outlined
                          placeholder="Select an image for your logo."
                          hint="Preferred sizes: Vertical: 160px * 160px Horizontal: 350px * 75px"
                          persistent-hint
                          show-size
                          small-chips
                          prepend-icon="mdi-paperclip"
                          :accept="allowed_files"
                          :loading="loading.logoFile"
                          :disabled="logoFile.length >= 1"
                          @change="uploadFiles(files.logoFile, 'logoFile')"
            />
            <v-chip-group>
              <v-chip v-for="(file, key) in logoFile" :key="key" close @click:close="removeFile(file.id, 'logoFile')">
                {{ file.name }}
              </v-chip>
            </v-chip-group>

            <v-file-input v-model="files.headerFile"
                          outlined
                          placeholder="Select an image for the header."
                          hint="Preferred sizes: 1280px * 768px"
                          persistent-hint
                          show-size
                          small-chips
                          prepend-icon="mdi-paperclip"
                          :accept="allowed_files"
                          :loading="loading.headerFile"
                          :disabled="headerFile.length >= 1"
                          @change="uploadFiles(files.headerFile, 'headerFile')"
            />
            <v-chip-group>
              <v-chip v-for="(file, key) in headerFile" :key="key" close @click:close="removeFile(file.id, 'headerFile')">
                {{ file.name }}
              </v-chip>
            </v-chip-group>

            <v-file-input v-model="files.servicesFile"
                          outlined
                          placeholder="Select an image for the Services section."
                          hint="Preferred sizes: 512px * 512px"
                          persistent-hint
                          show-size
                          small-chips
                          prepend-icon="mdi-paperclip"
                          :accept="allowed_files"
                          :loading="loading.servicesFile"
                          :disabled="servicesFile.length >= 1"
                          @change="uploadFiles(files.servicesFile, 'servicesFile')"
            />
            <v-chip-group>
              <v-chip v-for="(file, key) in servicesFile" :key="key" close @click:close="removeFile(file.id, 'servicesFile')">
                {{ file.name }}
              </v-chip>
            </v-chip-group>

            <v-file-input v-model="files.aboutFile"
                          outlined
                          placeholder="Select an image for the About section."
                          hint="Preferred sizes: 640px * 570px"
                          persistent-hint
                          show-size
                          small-chips
                          prepend-icon="mdi-paperclip"
                          :accept="allowed_files"
                          :loading="loading.aboutFile"
                          :disabled="aboutFile.length >= 1"
                          @change="uploadFiles(files.aboutFile, 'aboutFile')"
            />
            <v-chip-group>
              <v-chip v-for="(file, key) in aboutFile" :key="key" close @click:close="removeFile(file.id, 'aboutFile')">
                {{ file.name }}
              </v-chip>
            </v-chip-group>
          </v-form>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import {
  readUploadedFile,
  checkMimeType,
  checkFileSize,
  uploadFile,
  deleteFile } from '@/helpers/file-upload'

export default {
  name: 'MediaFiles',
  data () {
    return {
      files: {
        logoFile: [],
        headerFile: [],
        servicesFile: [],
        aboutFile: [],
      },
      allowed_files: [
        'image/bmp',
        'image/gif',
        'image/vnd.microsoft.icon',
        'image/jpeg',
        'image/png',
        'image/svg+xml',
        'text/plain',
      ],
      allowed_size: 2, // in mb
      loading: {
        logoFile: false,
        headerFile: false,
        servicesFile: false,
        aboutFile: false,
      }
    }
  },
  computed: {
    ...mapGetters({
      model: 'wizard_model/starterSite',
    }),
    logoFile: {
      get () {
        return this.model.logoFile
      },
      set (val) {
        this.setLogoFile(val)
      }
    },
    headerFile: {
      get () {
        return this.model.headerFile
      },
      set (val) {
        this.setHeaderFile(val)
      }
    },
    servicesFile: {
      get () {
        return this.model.servicesFile
      },
      set (val) {
        this.setServicesFile(val)
      }
    },
    aboutFile: {
      get () {
        return this.model.aboutFile
      },
      set (val) {
        this.setAboutFile(val)
      }
    }
  },
  methods: {
    ...mapMutations({
      setLogoFile: 'wizard_model/SET_SS_LOGO_FILE',
      setHeaderFile: 'wizard_model/SET_SS_HEADER_FILE',
      setServicesFile: 'wizard_model/SET_SS_SERVICES_FILE',
      setAboutFile: 'wizard_model/SET_SS_ABOUT_FILE',
    }),
    checkTypes (files, types) {
      let tmp = []
      let file = []
      file.push(files)

      tmp = file.filter(file => {
        if (checkMimeType(file, types)) {
          return file
        }
      })

      return tmp
    },
    checkSize (files, size) {
      let tmp = []

      tmp = files.filter(file => {
        if (checkFileSize(file, size)) {
          return file
        }
      })

      return tmp
    },
    async convertFile (files) {
      let tmp = []
      for await (let file of files) {
        try {
          tmp.push(await readUploadedFile(file))
        } catch (e) {
          console.warn(e)
        }
      }
      return tmp
    },
    async uploadFiles (photos = [], ctx) {
      let files = []
      let ids = []

      if (photos.length !== 0) {
        this.loading[ctx] = true
        // Filter unsupported files
        files = this.checkTypes(photos, this.allowed_files)
        // Filter files with a big size
        files = this.checkSize(files, this.allowed_size)
        // Convert files to readable format
        files = await this.convertFile(files)

        for await (let file of files) {
          try {
            const id = await uploadFile(file)
            ids.push({
              name: file.file_name,
              id: id
            })
          } catch (e) {
            console.warn(e)
          }
        }
        this.loading[ctx] = false
        this.files[ctx] = []

        switch (ctx) {
          case 'logoFile':
            this.logoFile = {
              mode: 'add',
              files: ids
            }

            break
          case 'headerFile':
            this.headerFile = {
              mode: 'add',
              files: ids
            }

            break
          case 'servicesFile':
            this.servicesFile = {
              mode: 'add',
              files: ids
            }

            break
          case 'aboutFile':
            this.aboutFile = {
              mode: 'add',
              files: ids
            }

            break
        }
        //
        // if (ctx === 'logo') {
        //   this.logoFiles = {
        //     mode: 'add',
        //     files: ids
        //   }
        // } else {
        //   this.additionalFiles = {
        //     mode: 'add',
        //     files: ids
        //   }
        // }
      }
    },
    async removeFile (id = null, ctx) {
      try {
        const files = this[ctx]

        await deleteFile(id)
        this[ctx] = files.filter(item => {
          return item.id !== id
        })
      } catch (e) {
        console.warn(e)
      }
    }
  }
}
</script>
